__turbopack_context__.v({
  "container": "rR6McW_container",
  "coverageItem": "rR6McW_coverageItem",
  "coverageList": "rR6McW_coverageList",
  "links": "rR6McW_links",
  "logo": "rR6McW_logo",
  "readMore": "rR6McW_readMore",
});
